module.exports = __webpack_public_path__ + "static/media/xiaoniu-new.jpg";